import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.css'
window._swal = swal; // make visible globally for javascript/
import flatpickr from "flatpickr";

import 'flatpickr/dist/themes/light.css'
import 'flatpickr/dist/plugins/confirmDate/confirmDate.css'
import 'flatpickr/dist/plugins/monthSelect/style.css'

import 'file-viewer'
import 'pdfjs-dist'

import 'jquery-ui'
import 'jquery-ui/themes/base/all.css';

import 'jquery.fancytree/dist/skin-lion/ui.fancytree.css';
import 'jquery.fancytree';